module.exports = __webpack_public_path__ + "img/caihui01.cebd92ef.png";